<template>
  <div id="print">

    <div class="book m-auto">

      <div
        v-for="(data, idx) in Math.ceil(purchase.orders.length/maxOrderLists)"
        :key="idx"
        :style="`font-size: ${fontSize}%;`"
        class="page"
      >
        <div class="subpage">
          <div class="top-header">
            <div
              v-if="idx == 0"
              class="company-info">
              <img
                v-if="shopInfo.logo.thumbnail"
                :src="shopInfo.logo.thumbnail">
              <div class="name">
                <strong class="text-black">{{ shopInfo.shop_name }}</strong>
                <p class="max-line-3">{{ shopInfo.info.location.address }}</p>
                <p
                  v-if="shopInfo.info.vat.taxpayer_no"
                  class="max-line-3">
                  {{ $t('message.taxpayerno') }}:
                  {{ shopInfo.info.vat.taxpayer_no }}
                </p>
                <p
                  v-if="getPartnerContact(shopInfo.contacts).tel"
                  class="max-line-3">
                  {{ $t('message.tel') }}:
                  {{ getPartnerContact(shopInfo.contacts).tel }}
                </p>
              </div>
            </div>
            <div class="document-type">
              <h2 class="text-black">{{ $t('documents.po') }}</h2>
              <p>{{ purchase.po_code }}</p>
            </div>
          </div>
          <div
            v-if="idx == 0"
            class="content">
            <div class="left">
              <div class="section">
                <p class="label">{{ $t('message.vendor') }}</p>
                <p class="detail">{{ purchase.vendor.vendor_name }}</p>
              </div>
              <div
                v-if="getPartnerContact(purchase.vendor.contacts).tel"
                class="section">
                <p class="label">{{ $t('message.tel') }}</p>
                <p class="detail">{{ getPartnerContact(purchase.vendor.contacts).tel }}</p>
              </div>
              <div
                v-if="purchase.vendor.address"
                class="section">
                <p class="label">{{ $t('message.address') }}</p>
                <p class="detail max-line-4">{{ purchase.vendor.address }}</p>
              </div>
              <div
                v-if="purchase.vendor.tax_id"
                class="section">
                <p class="label">{{ $t('message.taxpayerno') }}</p>
                <p class="detail">{{ purchase.vendor.tax_id }}</p>
              </div>
            </div>
            <div class="right">
              <div class="section">
                <p class="label">{{ $t('message.date') }}</p>
                <p class="detail">{{ getDate(purchase.created_at) }}</p>
              </div>
              <div class="section">
                <p class="label">{{ $t('message.credittype') }}</p>
                <template>
                  <p
                    v-if="purchase.credit.type == 'cash'"
                    class="detail">{{ $t('message.cash') }}</p>
                  <p
                    v-else
                    class="detail">{{ $t('message.creditdasys', {number: purchase.credit.days}) }}</p>
                </template>
              </div>
              <div
                v-if="purchase.credit.type == 'days'"
                class="section">
                <p class="label">{{ $t('message.scheduled_at') }}</p>
                <p class="detail">{{ getDate(purchase.scheduled_at) }}</p>
              </div>
              <div
                v-if="refCodes.length"
                class="section">
                <p class="label">{{ $t('message.reference') }}</p>
                <p
                  class="detail"
                  style="display: flex;flex-direction: column;">
                  <span
                    v-for="(refCode, index) in refCodes"
                    :key="index"
                  >
                    {{ refCode }}
                  </span>
                </p>
              </div>
            </div>
          </div>
          <div class="order">
            <table>
              <thead>
                <tr>
                  <td width="10px"><b>#</b></td>
                  <td><b>{{ $t('message.description') }}</b></td>
                  <td class="text-right"><b>{{ $t('message.quantity') }}</b></td>
                  <td
                    class="text-right"
                    style="min-width: 100px;"><b>{{ $t('message.unitprice') }}</b></td>
                  <td
                    v-if="total.discount > 0 && foundDiscount"
                    class="text-right"><b>{{ $t('message.discount') }}</b></td>
                  <td class="text-right"><b>{{ $t('message.total') }}</b></td>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(item, idx_) in groupOrders[idx].orders"
                  :key="idx_"
                >
                  <td width="10px"><b>{{ (maxOrderLists*idx)+(idx_+1) }}</b></td>
                  <td>{{ item.description }}</td>
                  <td class="text-right">{{ getNumber(item.quantity) }}</td>
                  <td class="text-right">{{ getNumber(item.price) }}</td>
                  <td
                    v-if="total.discount > 0 && foundDiscount"
                    class="text-right">
                    <span v-if="getDiscountInfo(item)">
                      <template>
                        <span v-if="getDiscountInfo(item).type == 'percentage'">{{ getNumber(getDiscountInfo(item).amount) }}%</span>
                        <span v-else>{{ getNumber(getDiscountInfo(item).amount) }} {{ currency }}</span>
                      </template>
                    </span>
                  </td>
                  <td class="text-right">{{ getNumber(getOrderTotal(item)) }}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div
            v-if="Math.ceil(purchase.orders.length/maxOrderLists) > 0 && idx !== (Math.ceil(purchase.orders.length/maxOrderLists)-1)"
            class="next-page">
            {{ $t('message.havenextpage') }}
          </div>

          <div
            v-if="idx >= (Math.ceil(purchase.orders.length/maxOrderLists)-1)"
            class="footer">

            <div class="note">
              <div
                v-if="purchase.note"
                class="section">
                <p>{{ $t('message.note') }}</p>
                <p style="white-space: pre;word-wrap: break-word; overflow-wrap: break-word; white-space: normal;">{{ purchase.note }}</p>
              </div>
            </div>

            <div class="total">

              <div class="section">

                <div
                  v-if="foundDiscount || foundTaxes"
                  class="section row m-0">
                  <div class="label mb-2">
                    {{ $t('message.total') }}
                  </div>
                  <div class="detail mb-2 text-right">
                    {{ getNumber(total.sub) }}
                  </div>
                </div>

                <div
                  v-if="total.discount > 0 && foundDiscount"
                  class="section row m-0">
                  <div class="label mb-2">
                    {{ $t('message.discount') }}
                  </div>
                  <div class="detail mb-2 text-right">
                    {{ getNumber(total.discount) }}
                  </div>
                </div>

                <div
                  v-if="total.discount > 0 && foundDiscount"
                  class="section row m-0">
                  <div class="label mb-2">
                    {{ $t('message.discounted_total') }}
                  </div>
                  <div class="detail mb-2 text-right">
                    {{ getNumber(total.sub - total.discount) }}
                  </div>
                </div>

                <div
                  v-if="total.taxes.vat.inclusive > 0 && foundTaxes"
                  class="section row m-0">
                  <div class="label mb-2">
                    {{ $t('message.totalexcludingvat') }}
                  </div>
                  <div class="detail mb-2 text-right">
                    {{ getNumber(total.untaxed) }}
                  </div>
                </div>

                <div
                  v-for="(tax, index) in taxResults"
                  :key="index"
                  class="section row m-0">
                  <div class="label mb-2">
                    {{ tax.displayText }}
                  </div>
                  <div class="detail mb-2 text-right">
                    {{ getNumber(tax.total) }}
                  </div>
                </div>

                <div class="section row m-0">
                  <div class="label">
                    {{ $t('message.grandtotal') }}
                  </div>
                  <div class="detail text-right">
                    <span class="text-underline-border">
                      {{ getNumber(total.grand) }}
                    </span>
                  </div>
                </div>

              </div>

            </div>

            <div :class="['signature', { 'non-fixed-bottom': !isFixedSignatureBottom }]">
              <div class="left">
                <div class="title max-line-1">
                  {{ purchase.vendor.vendor_name }}
                </div>
                <div class="info">
                  <div class="name">
                    {{ $t('message.name') }}
                  </div>
                  <div class="date">
                    {{ $t('message.date') }}
                  </div>
                </div>
              </div>
              <div class="right">
                <div class="title max-line-1">
                  {{ shopInfo.shop_name }}
                </div>
                <div class="info">
                  <div class="name">
                    <p style="margin: 0;">
                      {{ $t('message.name') }}
                    </p>
                    <p
                      v-if="shopInfo.shop_id === '63d8813021671ace1eb7269b'"
                      style="margin: 0;">
                      ด้วยความเคารพ
                    </p>
                  </div>
                  <div class="date">
                    {{ $t('message.date') }}
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>

    </div>

  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import _ from 'lodash'

export default {
  props: {
    purchase: {
      type: Object,
    },
    fontSize: {
      type: Number,
    },
    isFixedSignatureBottom: {
      type: Boolean,
    },
  },
  data () {
    return {
      maxOrderLists: 15,
    }
  },
  computed: {
    ...mapGetters({
      shopInfo: 'getShopInfo',
      getPartnerContact: 'getPartnerContact',
      currency: 'getCurrency',
    }),
    total () {
      return this.getTotal(this.purchase.orders)
    },
    taxResults () {
      const isGroupTaxName = false
      return this.getTaxesByOrders(this.purchase.orders, isGroupTaxName).map((tax) => {
        return {
          form_type: tax.form_type,
          taxRate: tax.amount,
          total: (() => {
            if (tax.amount <= -1) {
              return Math.abs(tax.total)
            }
            return tax.total
          })(),
          displayText: tax.displayText,
        }
      })
    },
    vatRate () {
      var vatPercent = undefined
      for (let i in this.purchase.orders) {
        let order = this.purchase.orders[i]
        for (let j in order.taxes) {
          let tax = order.taxes[j]
          if (tax.name == '{vat}') {
            vatPercent = tax.amount
          }
        }
      }
      return vatPercent
    },
    whtRate () {
      var whtPercent = undefined
      for (let i in this.purchase.orders) {
        let order = this.purchase.orders[i]
        for (let j in order.taxes) {
          let tax = order.taxes[j]
          if (tax.name == '{wht}') {
            whtPercent = tax.amount
          }
        }
      }
      return whtPercent
    },
    foundDiscount () {
      var found = false
      this.purchase.orders.map(order => {
        if (order.discounts.length > 0) found = true
      })
      return found
    },
    foundVat () {
      var found = false
      this.purchase.orders.map(order => {
        order.taxes.map(tax => {
          if (tax.name == '{vat}') {
            found = true
          }
        })
      })
      return found
    },
    foundWht () {
      var found = false
      this.purchase.orders.map(order => {
        order.taxes.map(tax => {
          if (tax.name == '{wht}') {
            found = true
          }
        })
      })
      return found
    },
    foundTaxes () {
      var found = false
      this.purchase.orders.map(order => {
        if (order.taxes.length > 0) found = true
      })
      return found
    },
    groupOrders () {
      var results = []
      var currentIdx = 0

      for (let i = 0; i < Math.ceil(this.purchase.orders.length / this.maxOrderLists); i++) {
        var page = i + 1
        results.push({
          'page': page,
          'orders': [],
        })
      }

      for (let i = 0; i < this.purchase.orders.length; i++) {
        let order = this.purchase.orders[i]

        if (i % (this.maxOrderLists) == 0 && i !== 0) {
          currentIdx++
        }

        results[currentIdx].orders.push(order)
      }

      return results
    },
    refCodes() {
      try {
        return [
          this.purchase.reference.purchase_requisition ? this.purchase.reference.purchase_requisition.po_code : null,
          ...this.purchase.reference.goodsreceipts ? this.purchase.reference.goodsreceipts.map((gr) => gr.gr_code) : [],
        ].filter((v) => v)
      } catch (err) {
        return []
      }
    },
  },
  methods: {
    ...mapActions([

    ]),
    getDiscountInfo (order) {
      var discountType = null
      var discountAmount = null

      for (let i in order.discounts) {
        discountType = order.discounts[i].value_type
        discountAmount = order.discounts[i].value_amount
      }

      if (!discountType && !discountAmount) {
        return null
      }

      return {
        type: discountType,
        amount: discountAmount,
      }
    },
    getVatInfo (order) {
      var taxType = null
      var taxAmount = null

      for (let i in order.taxes) {
        if (order.taxes[i].name == '{vat}') {
          taxType = order.taxes[i].type
          taxAmount = order.taxes[i].amount
        }
      }

      if (!taxType && !taxAmount) {
        return null
      }

      return {
        type: taxType,
        amount: taxAmount,
      }
    },
    getOrderTotal (order) {
      var total = 0

      var discountType = null
      var discountAmount = null

      var taxType = null
      var taxAmount = null

      let discountInfo = this.getDiscountInfo(order)
      let taxInfo = this.getVatInfo(order)

      let price = parseFloat(order.price)
      price = price || 0
      let quantity = parseFloat(order.quantity)
      quantity = quantity || 0
      let subtotal = price * quantity

      if (discountInfo) {
        discountType = discountInfo.type
        discountAmount = discountInfo.amount
      }

      if (taxInfo) {
        taxType = taxInfo.type
        taxAmount = taxInfo.amount
      }

      // discount
      if (!discountType) {
        total = subtotal
      } else {
        if (discountType == 'percentage') {
          total = (subtotal) * ((100 - discountAmount) / 100)
        } else {
          total = subtotal - discountAmount
        }
      }

      // untaxed
      if (taxType == 'include') {
        total = total * 100 / (100 + taxAmount)
      }

      return this.currencyFormatter(total, { code: this.currency, symbol: '' }).replace(/,/g, '')
    },
  },
  created: async function () {

  },
  mounted: function () {

  },
}
</script>

<style scoped>
  @page {
      size: A4;
      margin: 0;
  }

  @media print {
      #print .page {
          margin: 0;
          border: initial;
          border-radius: initial;
          width: initial;
          min-height: initial;
          box-shadow: initial;
          background: initial;
          page-break-after: always;
      }
  }
</style>



// WEBPACK FOOTER //
// src/components/apps/purchases/po/include/PrintPurchase.vue